"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.8892 12.3746c-2.1479 2.1479-2.1479 5.6303 0 7.7782 2.148 2.1478 5.6303 2.1478 7.7782 0l9.1924-9.1924c2.1479-2.148 2.1479-5.6303 0-7.7782s-5.6303-2.1479-7.7782 0l-9.1924 9.1924zm10.6066-7.7782-1.6997 1.6998 4.9497 4.9497 1.6998-1.6997c1.3668-1.3669 1.3668-3.583 0-4.9498-1.3669-1.3668-3.5829-1.3668-4.9498 0zm-6.1997 6.1998 3.0858-3.0858 4.9497 4.9497-3.0858 3.0858-4.9497-4.9497zm-1.4142 1.4142-1.5785 1.5784c-1.3668 1.3668-1.3668 3.5829 0 4.9498 1.3669 1.3668 3.583 1.3668 4.9498 0l1.5784-1.5785-4.9497-4.9497z"
  })];
};

exports.default = _default;